import { useEffect, useState } from "react";
import { auth } from "./firebase";
import { onAuthStateChanged } from "firebase/auth";
import Footer from "./components/Footer";
import Navbar from './components/navbar';
import GuestView from './components/GuestView';
import LoggedInView from './components/LoggedInView';
import { WhoWeAreContent } from "./components/who_we_are";
import { VisionContent } from "./components/vision";
import { MissionContent } from "./components/mission";
import { SuccessStoriesContent } from "./components/sucess_storeis";
import { FiInfo, FiTarget, FiStar, FiUsers } from "react-icons/fi";

const aboutTabs = [
  { key: "whoweare", label: "Who We Are", icon: <FiInfo className="w-5 h-5 mr-2" /> },
  { key: "vision",   label: "Our Vision",  icon: <FiTarget className="w-5 h-5 mr-2" /> },
  { key: "mission",  label: "Our Mission", icon: <FiStar className="w-5 h-5 mr-2" /> },
  { key: "stories",  label: "Success Stories", icon: <FiUsers className="w-5 h-5 mr-2" /> },
] as const;
type TabKey = typeof aboutTabs[number]["key"];

const HomePage = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [activeTab, setActiveTab] = useState<TabKey>("whoweare");

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setIsLoggedIn(!!user);
    });
    return () => unsubscribe();
  }, []);

  return (
    <div className="min-h-screen bg-black">
      <Navbar />
      {isLoggedIn ? (
        <LoggedInView />
      ) : (
        <>
          <div className="flex-1 px-4 md:px-12 lg:px-2">
            <main><GuestView /></main>
          </div>

          {/* About Us section — guests only */}
          <div id="about" className="w-full max-w-[1440px] mx-auto px-4 md:px-12 lg:px-24 py-20" style={{ color: "white" }}>
            <h2 className="font-[Sora] font-semibold text-[28px] md:text-[35px] text-center mb-12">About Us</h2>
            <div className="flex flex-1 gap-8 relative">
              <div className="w-48 shrink-0 hidden md:flex flex-col gap-3 sticky top-24 h-fit">
                {aboutTabs.map((t) => (
                  <button key={t.key} onClick={() => setActiveTab(t.key)}
                    className={`flex items-center text-left rounded-md px-4 py-3 text-sm font-medium transition border ${activeTab === t.key ? "text-white border-orange-500 shadow" : "bg-black border-white/10 text-white hover:bg-white/5"}`}
                    style={activeTab === t.key ? { background: "rgba(255, 84, 31, 1)" } : undefined}>
                    {t.icon}{t.label}
                  </button>
                ))}
              </div>
              <div className="flex-1 min-w-0 min-h-[400px] md:ml-4 hidden md:block">
                {activeTab === "whoweare" && <WhoWeAreContent />}
                {activeTab === "vision"   && <VisionContent />}
                {activeTab === "mission"  && <MissionContent />}
                {activeTab === "stories"  && <SuccessStoriesContent />}
              </div>
              <div className="md:hidden flex flex-col gap-6 w-full">
                {[
                  { icon: <FiInfo className="w-5 h-5 mr-2" />,   label: "Who We Are",      content: <WhoWeAreContent /> },
                  { icon: <FiTarget className="w-5 h-5 mr-2" />, label: "Our Vision",      content: <VisionContent /> },
                  { icon: <FiStar className="w-5 h-5 mr-2" />,   label: "Our Mission",     content: <MissionContent /> },
                  { icon: <FiUsers className="w-5 h-5 mr-2" />,  label: "Success Stories", content: <SuccessStoriesContent /> },
                ].map((s) => (
                  <div key={s.label} className="bg-black/20 border border-white/10 rounded-lg p-4">
                    <div className="flex items-center mb-4">{s.icon}<h3 className="text-lg font-medium">{s.label}</h3></div>
                    {s.content}
                  </div>
                ))}
              </div>
            </div>
          </div>
          <Footer />
        </>
      )}
    </div>
  );
};

export default HomePage;